var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFlagIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2017 3.55316L1.41178 0.056744C1.1978 -0.0201771 0.959345 0.0119899 0.774035 0.143455C0.588026 0.27492 0.477539 0.487502 0.477539 0.714769V14.0011H1.8761V8.20059L11.2017 4.86991C11.4801 4.77061 11.6661 4.50698 11.6661 4.21188C11.6661 3.91678 11.4801 3.65246 11.2017 3.55316Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlagIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "flag-icon.300f1d0c4d99877c01d4705e16ae3802.svg";